import { CuscoClientId } from 'store/api/ApiConstants';
import { clientVersion } from 'core-framework/constant/ApplicationInfo';
import { fetchResponse } from 'store/api/apiUtils';
import { getBootstrapConfig } from 'core/window/windowService';
import { host } from 'core-framework/window/location';
import { logout } from 'component/page/login/logout';
import { CuscoCampaignPlatform } from 'core/type/CuscoResponse.types';
import { AppConfiguration } from 'core/configuration/AppConfiguration';

export const getCampaignHeaders = () => {
    const bootstrapConfig = getBootstrapConfig();
    return {
        'X-CLIENT-ID': CuscoClientId.toString(),
        'AG-WHITELABEL-ID': String(bootstrapConfig.whiteLabelId),
        'AG-ORIGIN': bootstrapConfig.pageConfig.origin,
    };
};

const UniversalLoginPath = `https://${host()}/api/login`;

export const signInWithULToken = (pageTypeId: number) => {
    return fetchResponse(`${UniversalLoginPath}/token`, { method: 'POST', body: JSON.stringify({ pageTypeId }) });
};

// Can't find any usage, but too afraid to delete. hence, commented :)
// export const signInWithULTokenCronos = (pageTypeId: number) => {
//     return fetchResponse('/api/cronos/layout/logincallback', { method: 'POST', body: JSON.stringify({ pageTypeId }) });
// };

export const signOut = async (pageTypeId: number, whiteLabelId: number) => {
    await logout(pageTypeId, whiteLabelId);
};

export const getContinueYourBookingActivities = () => {
    const config = getBootstrapConfig();

    const { userId, origin, currencyCode, languageId, trafficGroupId, aid, cid } = config.pageConfig;

    const continueYourBookingBody = {
        userSettings: {
            currencyCode,
            languageLocale: config.language.locale,
            languageId,
        },
        clientInfo: {
            userId,
            memberId: config.memberId,
            clientVersion,
            applicationName: 2018,
        },
        platformInfo: {
            platform: CuscoCampaignPlatform.WEB_DESKTOP,
            pageTypeId: 1,
            sections: ['home_contents'],
        },
        sessionInfo: {
            cid,
            origin,
            aid,
            trafficGroupId,
        },
        extraProperties: {
            isActivitiesCYB: 'true',
        },
    };
    // Force call Prod Cusco on Activities prelive since it'll call QA Cusco and QA Cusco will call QA Search so it'll have no data due to activityId mismatch between prod and QA
    const cuscoHost = AppConfiguration.isPreLive() ? 'https://hkg.agoda.com/api/card/campaigns' : `https://${host()}/api/card/campaigns`;
    return fetchResponse(cuscoHost, { method: 'POST', headers: getCampaignHeaders(), body: continueYourBookingBody });
};
